module.exports = __webpack_public_path__ + "img/laporan-icon.352433cc.svg";